import axios from '@/plugins/axios'

const user = {
    namespaced: true,
    state: () => ({ 
            id: undefined,
            username: undefined,
            email: undefined,
            camps: [],
            isLoggedIn: false,
            isCampMaster: false,
            isAdmin: false,
            jwt: undefined,
    }),
    mutations: { 
        logout  (state) {
            state.id = undefined
            state.username =  undefined
            state.email = undefined
            state.isLoggedIn = false
            state.isAdmin = false
            state.jwt = undefined
            state.isCampMaster = false
            state.camps = []
        },
        login (state, stateData) {
            state.id = stateData.id
            state.username =  stateData.username
            state.email = stateData.email 
            state.isLoggedIn = true
            state.isAdmin = stateData.isAdmin
            state.isCampMaster = stateData.isCampMaster
            state.jwt = stateData.jwt
            state.camps = stateData.camps
        }
     },
    actions: { 
        async login (context, payload) {
            try {
                const response = await axios.post('/users/login', payload)
                const data = response.data

                const stateData = {
                    jwt: data.jwt,
                    username: data.userDetails.userName,
                    id: data.userDetails.id,
                    email: data.userDetails.email,
                    camps: data.userDetails.camps,
                    isAdmin: data.userDetails.isAdmin,
                    isCampMaster: data.userDetails.isCampMaster
                }
                
                axios.defaults.headers.common['Authorization'] = `Bearer ${data.jwt}`
                
                const storage = window.localStorage
                storage.setItem('jwt', data.jwt)
                storage.setItem('userId', data.userDetails.id)
                
                context.commit('login', stateData)

                return null
            } catch (e) {
                console.log(e.response)
                return e.response.data
            }
        },
        async tryExistingJwt(context) {
            const storage = window.localStorage
            const jwt = storage.getItem('jwt')
            const userId = storage.getItem('userId')

            if (jwt == null || userId == null) {
                return false
            }

            axios.defaults.headers.common['Authorization'] = `Bearer ${jwt}`
            
            try {
                const response = await axios.get(`/users/${userId}`)
                const data = response.data
                
                const stateData = {
                    jwt: jwt,
                    username: data.userName,
                    id: data.id,
                    email: data.email,
                    camps: data.camps,
                    isAdmin: data.isAdmin,
                    isCampMaster: data.isCampMaster
                }
                
                context.commit('login', stateData)
                return true
            } catch (e) {
                console.log(e)
                context.dispatch('logout')
                return false
            }
        },
        logout (context) {
            delete axios.defaults.headers.common['Authorization'];
            const storage = window.localStorage
            storage.removeItem('jwt')
            storage.removeItem('userId')
            context.commit('logout')
        }
    },
    getters: {  }
}

export default user;